module.exports = __webpack_public_path__ + "static/media/TACPES_MENU-normal.f3d4dacb.png";